import { createFileRoute } from "@tanstack/react-router"
import { AddDocumentTypePage } from "@/features/schema-management/pages/AddDocumentTypePage"

export const Route = createFileRoute("/_authenticated/agent/document/add")({
    component: AddDocumentTypePage,
})
